import { defineComponent as n, openBlock as r, createBlock as l, unref as a, mergeProps as p, withCtx as i, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconMail",
  __name: "IconMail",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (r(), l(a(c), p(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M21.75 6a1.25 1.25 0 0 0-1.25-1.25h-17A1.25 1.25 0 0 0 2.25 6v12a1.25 1.25 0 0 0 1.25 1.25h17A1.25 1.25 0 0 0 21.75 18V6m-1.5 1.099V6.25H3.75v.849l8.25 5.5 8.25-5.5M3.75 8.9v8.849h16.5V8.901l-7.556 5.038a1.25 1.25 0 0 1-1.387 0L3.75 8.901",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
